import { Suspense } from "react";
import { BrowserRouter as AppRouter, Route, Routes } from "react-router-dom";
import NotFoundPage from "../404";
import MainLayout from "../layouts/MainLayout";
import { Allocation } from "../views/Allocation";
import AllocationRequestWrapper from "../views/Allocation/AllocationRequest";
import SignIn from "../views/Auth/SignIn";
import SignUp from "../views/Auth/SignUp/SignUp";
import AddCart from "../views/CartController/AddCart";
import CartListTable from "../views/CartController/CartList";
import CartControllerView from "../views/CartController/CartList/CartView";
import InventoryView from "../views/CartController/CartList/CartView/Inventory/InventoryView";
import Commission from "../views/Configuration/Commission";
import ProductTable from "../views/Configuration/DayAvailable";
import MappingContainer from "../views/Configuration/Delivery";
import FilterTags from "../views/Configuration/FilterTags";
import Holidays from "../views/Configuration/Holidays";
import OrderTimes from "../views/Configuration/OrderTimes";
import PortionSizes from "../views/Configuration/PortionSizes";
import Promotions from "../views/Configuration/Promotions";
import AddPromotion from "../views/Configuration/Promotions/AddPromotion";
import EditPromotion from "../views/Configuration/Promotions/EditPromotion";
import CustomerList from "../views/Customers/CustomerList";
import CustomerView from "../views/Customers/CustomerView";
import Dashboard from "../views/Dashboard";
import CartAllocationPlanning from "../views/Distribution/Cart Allocation Planning";
import CartConfigurations from "../views/Distribution/Cart Configurations";
import CartLoadingManagement from "../views/Distribution/Cart Loading";
import OrderManagementSystem from "../views/Distribution/Order Management & Allocation/Production Entry";
import AddProductionPlan from "../views/Distribution/Order Management & Allocation/Production Entry/Add Production Plan";
import EditProductionPlan from "../views/Distribution/Order Management & Allocation/Production Entry/Edit Production Plan";
import DistributionPlan from "../views/Distribution/Production Allocation";
import Documents from "../views/Documents";
import Feedback from "../views/Feedback";
import HolidayHours from "../views/Holiday Hours";
import Home from "../views/Home";
import Marketing from "../views/Marketing";
import AddMenus from "../views/Menus/MenuList/AddMenus";
import MenusTable from "../views/Menus/MenuList/MenusTable";
import MenuTableView from "../views/Menus/MenuList/MenusTableView";
import UpdateMenus from "../views/Menus/MenuList/UpdateMenus";
import CreateOrg from "../views/Oraganizations/CreateOrg";
import OrganizationView from "../views/Oraganizations/DetailView";
import OrganizationList from "../views/Oraganizations/OrgList";
import CartItemRequestList from "../views/Orders/CartItemRequest/CartItemRequestList";
import CartItemRequestView from "../views/Orders/CartItemRequest/CartItemRequestView";
import CreateCartToCartOrder from "../views/Orders/CartItemRequest/CreateCartToCartOrders";
import CreateOrder from "../views/Orders/CreateOrder";
import DeliveryOrderManagement from "../views/Orders/DeliveryOrder";
import DeliveryRouteOptimizer from "../views/Orders/DeliveryRouteOptimizer";
import OrderListNew from "../views/Orders/OrderList";
import OrderSearch from "../views/Orders/OrderSearch";
import OrderActivityView from "../views/Orders/OrderActivityPage/index";
import OrderView from "../views/Orders/OrderViewPage";
import OrderRefund from "../views/Payments/OrderRefund";
import PreparationTime from "../views/PreparationTime";
import AddCustomizedMenu from "../views/Products/CustomizedMenu/AddCustomizedMenu";
import CustomizeMenuTable from "../views/Products/CustomizedMenu/CustomizeMenuTable";
import UpdateCustomizeMenu from "../views/Products/CustomizedMenu/UpdateCustomizeMenu";
import AddMenuItem from "../views/Products/MenuItem/AddMenuItem";
import ItemTable from "../views/Products/MenuItem/ItemTable";
import UpdateItemPage from "../views/Products/MenuItem/UpdateMenuItem";
import ViewMenuItem from "../views/Products/MenuItem/ViewMenuItem";
import AddDimension from "../views/Products/ProductGroups/AddDimension";
import AddDimensionValue from "../views/Products/ProductGroups/AddDimensionValue";
import DimensionsDetail from "../views/Products/ProductGroups/DimensionsDetail";
import EditDimension from "../views/Products/ProductGroups/EditDimension";
import EditDimensionValue from "../views/Products/ProductGroups/EditDimensionValue";
import AddMenu from "../views/Products/SetMenu/AddMenu";
import MenuTable from "../views/Products/SetMenu/MenuTable";
import UpdateMenu from "../views/Products/SetMenu/UpdateMenu";
import ViewMenu from "../views/Products/SetMenu/ViewMenu";
import Profile from "../views/Profile";
import AddRestaurant from "../views/Profile/AddRestaurant";
import RestaurantDetailsView from "../views/Profile/RestaurantDetailsView";
import RestaurantView from "../views/Profile/RestaurantView";
import EditReasturant from "../views/Profile/RestaurantView/EditRestaurant";
import Regular from "../views/Regular";
import RegularOverView from "../views/Regular/OverView";
import Reports from "../views/Reports";
import Settings from "../views/Settings";
import Subscriptions from "../views/Subscriptions";
import Users from "../views/Users";
import ProtectedRoute from "./protectedRoute";
import InAppCartOrders from "../views/Orders/InAppCartOrders";
import ViewOrderRefund from "../views/Payments/OrderRefund/ViewOrderRefund";
import ReturnRequests from "../views/Payments/ReturnRequests";
import ViewReturnRequest from "../views/Payments/ReturnRequests/ViewReturnRequest";
import CustomizeMenuType from "../views/Products/ProductGroups";



const Router = () => {
  return (
    <AppRouter>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/" index element={<Home />} />
            <Route path="/home" index element={<Home />} />
            <Route
              path="/home/Edit-Restaurant"
              index
              element={<EditReasturant />}
            />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/reports" element={<Reports />} />
            {/* -------------- Payments Routes ------------- */}
            <Route path="/payments/refund-orders" element={<OrderRefund />} />
            <Route
              path="/payments/refund-orders/view-order-refund"
              element={<ViewOrderRefund />}
            />
            <Route
              path="/payments/return-requests"
              element={<ReturnRequests />}
            />
            <Route
              path="/payments/return-requests/view-return-request"
              element={<ViewReturnRequest />}
            />
            {/* -------------- Payments Routes ------------- */}
            <Route path="/menu" element={<RegularOverView />} />
            <Route path="/menu/regular" element={<Regular />}>
              <Route index element={<RegularOverView />} />
              <Route
                path="/menu/regular/overview"
                element={<RegularOverView />}
              />
              <Route path="/menu/regular/setMenu" element={<MenuTable />} />
              <Route path="/menu/regular/categories" />
              <Route path="/menu/regular/items" element={<ItemTable />} />
            </Route>
            <Route path="/menu/subscriptions" element={<Subscriptions />} />
            <Route path="/holiday_hours" element={<HolidayHours />} />
            <Route path="/marketing" element={<Marketing />} />
            <Route path="/preparation_time" element={<PreparationTime />} />
            <Route path="/users" element={<Users />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/profile/add-restaurant" element={<AddRestaurant />} />
            <Route
              path="/profile/edit-restaurant"
              element={<RestaurantView />}
            />
            <Route
              path="/profile/restaurant-details-view"
              element={<RestaurantDetailsView />}
            />

            {/* ---------------Products(Menu items)-------------------- */}
            <Route
              path="/productCatalogue/stock-keeping-unit"
              element={<ItemTable />}
            />
            <Route
              path="/productCatalogue/stock-keeping-unit/add-product"
              element={<AddMenuItem />}
            />
            <Route
              path="/productCatalogue/stock-keeping-unit/update-product"
              element={<UpdateItemPage />}
            />
            <Route
              path="/productCatalogue/stock-keeping-unit/view-product"
              element={<ViewMenuItem />}
            />

            {/* ---------------Products(Set menu)-------------------- */}
            <Route
              path="/productCatalogue/combo-menu"
              element={<MenuTable />}
            />
            <Route
              path="/productCatalogue/combo-menu/add-menu"
              element={<AddMenu />}
            />
            <Route
              path="/productCatalogue/combo-menu/update-menu"
              element={<UpdateMenu />}
            />
            <Route
              path="/productCatalogue/combo-menu/view-menu"
              element={<ViewMenu />}
            />

            {/* ---------------Products(Customize menu)-------------------- */}
            <Route
              path="/productCatalogue/products"
              element={<CustomizeMenuTable />}
            />
            <Route
              path="/productCatalogue/products/add-product"
              element={<AddCustomizedMenu />}
            />
            <Route
              path="/productCatalogue/products/update-product"
              element={<UpdateCustomizeMenu />}
            />

            <Route
              path="/productCatalogue/product-groups"
              element={<CustomizeMenuType />}
            />
            <Route
              path="/productCatalogue/product-groups/:menuType/dimensions"
              element={<DimensionsDetail />}
            />
            <Route
              path="/productCatalogue/product-groups/:menuType/:customMenuItemTypeId/add-dimension"
              element={<AddDimension />}
            />
            <Route
              path="/productCatalogue/product-groups/:menuType/edit-dimension/:dimensionId"
              element={<EditDimension />}
            />
            <Route
              path="/productCatalogue/product-groups/:menuType/dimensions/:dimensionId/add-value"
              element={<AddDimensionValue />}
            />
            <Route
              path="/productCatalogue/product-groups/:menuType/dimensions/:dimensionId/edit-value/:valueId"
              element={<EditDimensionValue />}
            />

            {/* ---------------Menu(Menu-List)-------------------- */}
            <Route path="/menu/menu-list" element={<MenusTable />} />
            <Route
              path="/menu/menu-list/menu-view"
              element={<MenuTableView />}
            />
            <Route
              path="/menu/menu-list/add-menu-list"
              element={<AddMenus />}
            />
            <Route path="/menu/menu-list/menu-edit" element={<UpdateMenus />} />

            {/*-----------------Configuration--------------- */}
            <Route
              path="/configuration/day-available"
              element={<ProductTable />}
            />
            <Route
              path="/configuration/portion-sizes"
              element={<PortionSizes />}
            />
            <Route path="/configuration/commission" element={<Commission />} />
            <Route path="/configuration/filter-tags" element={<FilterTags />} />

            <Route
              path="/configuration/delivery-zones"
              element={<MappingContainer />}
            />
            <Route path="/configuration/promotions" element={<Promotions />} />
            <Route
              path="/configuration/promotions/add-promotion"
              element={<AddPromotion />}
            />
            <Route
              path="/configuration/promotions/edit-promotion"
              element={<EditPromotion />}
            />
            <Route path="/configuration/holidays" element={<Holidays />} />
            <Route path="/configuration/order-times" element={<OrderTimes />} />
            {/*-----------------Cart Controller--------------- */}
            <Route path="/carts/cart-list" element={<CartListTable />} />
            <Route
              path="/carts/cart-list/view"
              element={<CartControllerView />}
            />
            <Route path="/carts/add-new-cart" element={<AddCart />} />
            <Route
              path="/carts/cart-list/view/inventory-view"
              element={<InventoryView />}
            />

            {/*-----------------Order Controller--------------- */}
            <Route path="/orders/create-order" element={<CreateOrder />} />
            <Route path="/orders/pickup-orders" element={<OrderListNew />} />
            <Route path="/orders/pickup-orders/view" element={<OrderView />} />
            <Route path="/orders/search" element={<OrderSearch />} />
            <Route path="/orders/search/view" element={<OrderView />} />
            <Route
              path="/orders/activity/view"
              element={<OrderActivityView />}
            />
            <Route
              path="/orders/delivery-order"
              element={<DeliveryOrderManagement />}
            />
            <Route path="/orders/delivery-order/view" element={<OrderView />} />

            <Route
              path="/orders/cart-item-request"
              element={<CartItemRequestList />}
            />
            <Route
              path="/orders/cart-item-request/:id"
              element={<CartItemRequestView />}
            />

            <Route
              path="/orders/cart-item-request/create-cart-to-cart-order"
              element={<CreateCartToCartOrder />}
            />

            <Route
              path="/orders/delivery-route-optimizer"
              element={<DeliveryRouteOptimizer />}
            />

            <Route path="/orders/card-payment-abandoned-orders" element={<InAppCartOrders/>} />

            {/* Order Management */}

            {/*-----------------Customer Managment--------------- */}

            <Route path="/customers/customer-list" element={<CustomerList />} />

            <Route
              path="/customers/customer-list/:id"
              element={<CustomerView />}
            />

            {/*-----------------Customer Managment--------------- */}

            {/* <OrganizationList /> */}
            <Route
              path="/organizations/organization-list"
              element={<OrganizationList />}
            />

            <Route
              path="/organizations/organization-list/add-organization"
              element={<CreateOrg />}
            />

            <Route
              path="/organizations/organization-list/:id"
              element={<OrganizationView />}
            />
            {/* <OrganizationList /> */}
            <Route
              path="/distribution/orderManagement"
              element={<OrderManagementSystem />}
            />
            <Route
              path="/distribution/orderManagement/addProductionPlan"
              element={<AddProductionPlan />}
            />
            <Route
              path="/distribution/orderManagement/editProductionPlan"
              element={<EditProductionPlan />}
            />
            {/* Production Allocation */}
            <Route
              path="/distribution/directSaleAllocation"
              element={<DistributionPlan />}
            />
            <Route
              path="/distribution/cartAllocation"
              element={<CartAllocationPlanning />}
            />

            {/* ---------------Cart Configuration-------------------- */}
            <Route
              path="distribution/cart-configuration"
              element={<CartConfigurations />}
            />

            {/* ---------------Cart Loading Management-------------------- */}
            <Route
              path="/distribution/cart-loading"
              element={<CartLoadingManagement />}
            />

            {/* Allocation */}
            <Route
              path="/allocation/allocation-process"
              element={<Allocation />}
            />
            <Route
              path="/allocation/create-request"
              element={<AllocationRequestWrapper />}
            />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Suspense>
    </AppRouter>
  );
};

export default Router;
